<template>
  <div>
    <v-layout row class="mt-3">
      <v-flex xs10 sm5 md3>
        <v-select
          :items="column_items"
          item-value="value"
          v-model="sort_column"
          @change="sortBy()"
          label="Sort by"
          color="black"
          clearable
          hide-details
        ></v-select>
      </v-flex>
      <v-flex xs2 sm4 md3>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'asc'"
          :disabled="asc_desc == 'desc' || sort_column == 'no_default'"
          @click="selectAscDesc('desc')"
        >
          <v-icon small>arrow_downward</v-icon>
        </v-btn>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'desc'"
          :disabled="asc_desc == 'asc' || sort_column == 'no_default'"
          @click="selectAscDesc('asc')"
        >
          <v-icon small>arrow_upward</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="promotion_report_list"
      class="elevation-1 mt-4"
      style="background-color:white;padding:10px; border-radius:10px;"
    >
      <template
        slot="headerCell"
        slot-scope="props"
        style="background-color:black;"
      >{{ props.header.text }}</template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{props.item.no }}</td>
        <td>{{ props.item.promotion_name }}</td>
        <td
          class="text-xs-right"
        >{{props.item.promotion_unit == 1 ? (parseFloat(props.item.discount).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : props.item.discount}}</td>
        <td
          class="text-xs-right"
        >{{ (props.item.amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td>
        <td class="text-xs-center" v-if="props.item.used_cancel">
          <span style="color:green;">{{ props.item.used_cancel.split('/')[0] }}</span> /
          <span style="color:red;">{{ props.item.used_cancel.split('/')[1] }}</span>
        </td>
        <td v-else></td>
        <td
          class="text-xs-right"
        >{{ props.item.total_value_price ? (parseFloat(props.item.total_value_price).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}}</td>
        <td
          class="text-xs-right"
        >{{ props.item.total_paid_price ? (parseFloat(props.item.total_paid_price).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00' }}</td>
      </template>
      <template slot="footer" style="border:none;">
        <td></td>
        <td class="text-xs-right">
          <strong>Total</strong>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td
          class="text-xs-right"
        >{{ promotion_report_summary.total_value_price ? (parseFloat(promotion_report_summary.total_value_price).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}}</td>
        <td
          class="text-xs-right"
        >{{ promotion_report_summary.total_paid_price ? (parseFloat(promotion_report_summary.total_paid_price).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}}</td>
      </template>
    </v-data-table>
    <!-- <div class="main-title mt-4 mb-3">SUMMARY</div>
    <v-card style="border-radius:10px;">
      <v-card-text>
        <v-layout justify-center>
        <v-flex xs5>
          <div>
            <span class="title-store">ร้านไผ่ทอง</span> 
            <div style="color:#898989;">12/09/2019 - 12/10/2019</div>
            <v-divider class="mb-3"/>
          </div>
          <table width="100%">
            <tr>
              <td class="text-table">Total use</td>
              <td class="text-xs-center">xxxxx</td>
            </tr>
            <tr>
              <td class="text-table">Deduct Package 20%</td>
              <td class="text-xs-center">(xxxxx)</td>
            </tr>
            <tr>
              <td class="text-table">Paid store</td>
              <td class="text-xs-center" style="text-decoration:underline;">xxxxx</td>
            </tr>
          </table>
        </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>-->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "name"
        },
        { text: "Promotion", value: "promotion", sortable: false },
        {
          text: "Discount",
          value: "discount",
          sortable: false,
          align: "center"
        },
        { text: "Amount", value: "amount", sortable: false, align: "center" },
        {
          text: "Use / Cancel",
          value: "use",
          sortable: false,
          align: "center"
        },
        {
          text: "Value price (THB)",
          value: "value_price",
          sortable: false,
          align: "center"
        },
        {
          text: "Paid price (THB)",
          value: "paid_price",
          sortable: false,
          align: "center"
        }
      ],
      column_items: [
        {
          text: "Paid price (THB)",
          value: "total_paid_price",
          sortable: false,
          align: "center"
        }
      ],
      asc_desc: "asc",
      sort_column: "no_default",
      isSort: false
    };
  },
  watch: {
    promotion_report_list: {
      handler: function() {
        if (this.isSort == false) {
          this.asc_desc = "asc";
          this.sort_column = "no_default";
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      promotion_report_list: state =>
        state.fetchPromotionReport.promotion_report_list,
      promotion_report_summary: state =>
        state.fetchPromotionReport.promotion_report_summary
    })
  },
  methods: {
    async sortBy() {
      if (this.sort_column == undefined) {
        this.sort_column = "no_default";
        this.asc_desc = "asc";
      }

      this.isSort = true;
      const send_json_data = {
        data: this.promotion_report_list,
        field: this.sort_column,
        asc_desc: this.asc_desc
      };

      await this.$store.dispatch("sortData", send_json_data);
      await this.$store.commit("fetchPromotionReport/getExportReportForm");
      this.$store.commit("fetchPromotionReport/getExportSummaryForm");
      this.isSort = false;
    },
    selectAscDesc(value) {
      this.asc_desc = value;
      this.sortBy();
    }
  }
};
</script>
<style scoped>
.sort-btn {
  cursor: pointer;
  height: 30px;
  width: 30px;
  background-color: #fafafa;
  border: 1px solid #b8b8b8;
  border-radius: 10px;
  color: #757575;
  margin-top: 10px;
  margin-left: 20px;
}
/* .main-title {
  font-size: 22px;
  font-weight: bold;
}
.text-table {
  font-weight: bold;
  line-height: 30px;
}
.title-store {
  font-size: 19px;
  font-weight: bold;
} */
</style>

